<template>
  <DefaultLayout :title="title" :back-link="{ name: 'home', label: 'Liste des chants' }">
    <div class="edit-song" v-if="isAdmin">
        <SongEditForm :song="song" />
    </div>
    <div v-else class="alert alert-danger" role="alert">
      Vous devez être connecté en tant qu'admin pour accéder à cette page.
    </div>
  </DefaultLayout>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from "vuex";
import SongEditForm from "@/components/SongEditForm"
import DefaultLayout from "@/layouts/DefaultLayout";

export default {
  name: 'home',
  components: {
    SongEditForm,
    DefaultLayout
  },
  computed: {
    ...mapGetters(["isAdmin", "getSongById"]),
    song() {
      if (!this.$route.params.songId)
        return null;

      return this.getSongById(this.$route.params.songId);
    },
    title() {
      return this.song ? "Modification d'un chant" : "Nouveau chant"
    }
  },
  methods: {
    ...mapActions(["ensureSongs","stopSong"])
  },
  mounted() {
    this.ensureSongs();
    this.stopSong();
  }
}
</script>
